// extracted by mini-css-extract-plugin
export default {"imageIcon":"FloatingButton_imageIcon__7EyKQ","shake":"FloatingButton_shake__OM1cj"};